import * as React from 'react';

import Markdown from 'bundles/cms/components/Markdown';
import Faqs from 'bundles/design-system/components/Faqs';
import type { DegreePageContentFragment } from 'bundles/xddp/__generated__/contentfulTypes';

const FinancialSection = ({
  pageContent,
  showFinancialTab,
}: {
  pageContent: DegreePageContentFragment;
  showFinancialTab: boolean;
}) => {
  const { tuition, financialAid, financialAidFaqsCollection, additionalAdmissionResources } = pageContent;

  if (showFinancialTab) {
    return null;
  }

  return (
    <div className="rc-FinancialSection">
      <Markdown className="tuition rc-Section" source={tuition} />
      <Markdown className="financialAid" source={financialAid} />
      <Faqs faqs={financialAidFaqsCollection?.items} />
      <Markdown className="additionalResources rc-Section" source={additionalAdmissionResources} />
    </div>
  );
};

export default FinancialSection;
